module.exports = __webpack_public_path__ + "static/img/log_out.130f3894.svg";